/**
 * PageLoader — Suspense fallback for lazy-loaded route components.
 *
 * Displayed while a code-split page chunk is being fetched.
 * Keeps the layout shell (navbar/footer) visible; only the
 * content area shows this spinner.
 */

export function PageLoader() {
  return (
    <div className="flex min-h-[calc(100svh-4rem)] w-full flex-1 items-center justify-center">
      <div className="flex flex-col items-center gap-3">
        <p className="text-sm text-slate-400 font-inter">Loading…</p>
      </div>
    </div>
  );
}
